'use client';

import { Icon } from '@petsmart-ui/sparky';
import cn from 'classnames';
import type { MouseEvent } from 'react';

import { getBaseUrlJoined, trackMainNavLinkClick, trackNavigationHeaderClick } from '@libs/analytics';
import { usePageLayout } from '@libs/common-next';
import { handleServiceClick } from '@libs/experience-api';

import { getCategoryPath, trackCategoryPath } from '../MainMenu/utils';
import type { LegacyDrawerMenuItemProps } from './types';

export function LegacyDrawerMenuItem({
    category,
    categoryStack,
    handleCategoryClick,
    closeMenu,
}: LegacyDrawerMenuItemProps) {
    const { isAuthenticated, isSoftAuthenticated } = usePageLayout();

    const depth = categoryStack.length - 1;
    const type = category.type === 'image' ? 'text' : category.type;
    const classes = cn('category', `category--${type}`, { ['category--thin']: depth > 0 });
    const categoryPath = categoryStack.slice(1).map(c => c.displayText || '');
    const newPath = getCategoryPath(categoryPath, category.displayText);
    const trackNewPath = trackCategoryPath(newPath);
    const webUrl = category.link ?? '#';

    function handleLinkClick(event: MouseEvent) {
        handleServiceClick({
            authType: isAuthenticated,
            event,
            link: webUrl,
            isSoftAuthenticated,
        });

        trackMainNavLinkClick(trackNewPath);
        trackNavigationHeaderClick(trackNewPath, getBaseUrlJoined(webUrl) ?? '', 'main nav');
        closeMenu();
    }

    return (
        <li className={classes}>
            {category.categories?.length && category.specialType !== 'Shop By Brand' ? (
                <button onClick={() => handleCategoryClick(category)} className="category__button" type="button">
                    <span>{category.displayText}</span>
                    <Icon name="chevron-right" />
                </button>
            ) : (
                <a
                    className={category.shopAllCategory ? 'category__link category__link--shop-all' : 'category__link'}
                    onClick={event => handleLinkClick(event)}
                    href={webUrl}
                >
                    <span>{category.displayText}</span>
                </a>
            )}
        </li>
    );
}
